import styled from 'styled-components';

import {
  colorAccentLighten95,
  colorBlack900,
  colorGraySemiLight,
  fontFamilyPrimary,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Item = styled.tbody`
  ${({ $isExpanded }) =>
    !$isExpanded &&
    `
    & > tr:not(:first-child) {
      display: none;
    }
  `}
`;

export const MonthHeaderRow = styled.tr`
  cursor: pointer;

  & > td {
    background: ${colorAccentLighten95};
    border-top: 1px solid ${colorGraySemiLight};
  }

  &:hover > td {
    background: ${colorAccentLighten95};
    opacity: 0.95;
  }

  &:focus-visible {
    outline: 2px solid ${colorBlack900};
    outline-offset: -2px;
  }
`;

export const MonthHeaderCell = styled.td`
  padding: 8px;
  border: 0;
  vertical-align: middle;

  @media ${mediaQueryMobileLargeMin} {
    padding: 10px 16px;
  }
`;

export const SummaryCell = styled(MonthHeaderCell)`
  @media ${mediaQueryMobileLargeMin} {
    text-align: center;
  }
`;

export const TriggerMain = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
  width: 100%;
  font-family: ${fontFamilyPrimary};
  color: ${colorBlack900};
  text-align: left;
`;

export const TriggerIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;

  & > svg {
    transform: ${({ $isExpanded }) =>
      $isExpanded ? 'rotate(0deg)' : 'rotate(180deg)'};
  }
`;

export const MonthTitle = styled.span`
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  color: ${colorBlack900};
  text-transform: capitalize;
  white-space: nowrap;

  @media ${mediaQueryMobileLargeMin} {
    font-size: 16px;
    line-height: 28px;
  }
`;

export const Summary = styled.span`
  display: block;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  color: ${colorBlack900};
  white-space: nowrap;

  @media ${mediaQueryMobileLargeMin} {
    line-height: 24px;
  }
`;

export const SummaryMobile = styled(Summary)`
  margin-top: 4px;
  padding-left: 32px;

  @media ${mediaQueryMobileLargeMin} {
    display: none;
  }
`;

export const SummaryDesktop = styled(Summary)`
  display: none;

  @media ${mediaQueryMobileLargeMin} {
    display: block;
  }
`;
